'use strict';

require('../shared/base-entry');
require('./views/categories');
require('./views/category-offers');
require('../shared/post-entry');
